import { Ref } from 'vue';
import { useMediaQuery } from '@vueuse/core';

export const isSmartphone: Ref<boolean> = useMediaQuery('(max-width: 1093px)');
